export default __webpack_public_path__ + "static/media/engagement1.1ae81748.png";